import type { AxiosRequestConfig } from 'axios';

import type { HttpRequestConfig, HttpResponse } from '../http-client';

interface AxiosLikeResponse<T> {
	data: T;
	headers: unknown;
	status: number;
}

/**
 * Преобразует внутренний конфиг HTTP-клиента в формат, понятный Axios.
 *
 * @param config Конфиг запроса из адаптера приложения.
 * @returns Конфиг в формате Axios или undefined, если входной конфиг не передан.
 */
export const mapRequestConfig = (config?: HttpRequestConfig): AxiosRequestConfig | undefined => {
	if (!config) {
		return undefined;
	}

	return {
		headers: config.headers,
		params: config.params,
		signal: config.signal,
	};
};

/**
 * Приводит ответ в axios-подобном формате к унифицированному HttpResponse.
 *
 * @param response Ответ transport-слоя.
 * @returns Нормализованный ответ, который используется в приложении.
 */
export const toHttpResponse = <T>(response: AxiosLikeResponse<T>): HttpResponse<T> => ({
	status: response.status,
	data: response.data,
	headers: response.headers,
});
